import {
  connectRepriceQuoteButton,
  type RepriceQuoteButtonProps,
} from 'components/common-form/sidePanel/actions/quote/RepriceQuoteButton.connect';
import { useCrossBrowserContext } from 'hooks/useCrossBrowserContext';
import { FormattedMessage, useIntl } from 'react-intl';

function RepriceQuoteButtonRaw({ isHidden, isFormDirty, onReprice }: RepriceQuoteButtonProps) {
  const { formatMessage } = useIntl();
  const { isDirty, isLocked } = useCrossBrowserContext();
  const isDisabled = isDirty || isLocked || isFormDirty;

  return isHidden ? null : (
    <button
      type="button"
      className="btn btn-flat-primary-alt btn-icon"
      title={formatMessage({ id: 'sidePanel.repriceQuote' })}
      onClick={onReprice}
      disabled={isDisabled}
    >
      <i className="icon icon-md">refresh</i>
      <span className="visually-hidden">
        <FormattedMessage id="sidePanel.repriceQuote" />
      </span>
    </button>
  );
}

export const RepriceQuoteButton = connectRepriceQuoteButton(RepriceQuoteButtonRaw);
